/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Typography } from "antd";
import "./PageBanner.scss";
import { useAppSelector } from "hooks/reduxHooks";

const { Title } = Typography;

const PageBanner = () => {
  const lockerDetails: any = useAppSelector((state) => state.landingPage.lockerPortalDetails);

  return (
    <>
      {lockerDetails?.lockerPortalDetails ? (
        <div className="information-banner">
          <div
            className="banner-wrapper"
            style={{
              // eslint-disable-next-line quotes
              backgroundImage: `url("${lockerDetails?.lockerPortalDetails?.BannerImagePath}")`,
              backgroundPosition: "top center",
              backgroundSize: "cover",
            }}
          >
            {/* <div className="banner-image">
              <Image
                preview={false}
                className="banner-image"
                src={lockerDetails?.lockerPortalDetails?.BannerImagePath}
              />
            </div> */}
            <div className="banner-content">
              <Title level={2} className="banner-heading">
                {lockerDetails?.lockerPortalDetails?.BannerTitle}
              </Title>
              <Title level={3} className="banner-sub-heading">
                {lockerDetails?.lockerPortalDetails?.BannerSubTitle}
              </Title>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default PageBanner;
